import { render } from "./DashboardCountersOld.vue?vue&type=template&id=3f20838e"
import script from "./DashboardCountersOld.vue?vue&type=script&lang=js"
export * from "./DashboardCountersOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__